// Persist and restore an abandoned checkout so authors can resume mid-purchase.

const KEY = "authoros_abandoned_checkout";

export function saveAbandonedCheckout({ customer, orderId, razorpayOrderId, plan, total }) {
  try {
    const payload = {
      customer,
      orderId: orderId || null,
      razorpayOrderId: razorpayOrderId || null,
      plan: plan || [],
      total: total || 0,
      timestamp: Date.now(),
    };
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch (_e) { /* ignore */ }
}

export function readAbandonedCheckout({ maxAgeMs = 24 * 60 * 60 * 1000 } = {}) {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || !data.timestamp) return null;
    if (Date.now() - data.timestamp > maxAgeMs) {
      localStorage.removeItem(KEY);
      return null;
    }
    return data;
  } catch (_e) {
    return null;
  }
}

export function clearAbandonedCheckout() {
  try { localStorage.removeItem(KEY); } catch (_e) { /* ignore */ }
}
